import { getAllFilesFrontMatter } from "@/utils/blog/mdx";
import siteMetadata from "@/data/siteMetadata";
import ListLayout from "@/components/blog/layout/ListLayout";
import PageInfo from "@/components/PageInfo";
import Navbar from "@/components/Navbar";
import { Container } from "@chakra-ui/react";
import Footer from "@/components/Footer";

export const POSTS_PER_PAGE = 20;

export async function getStaticProps() {
  const posts = await getAllFilesFrontMatter("blog");
  const initialDisplayPosts = posts.slice(0, POSTS_PER_PAGE);
  const pagination = {
    currentPage: 1,
    totalPages: Math.ceil(posts.length / POSTS_PER_PAGE),
  };

  return { props: { initialDisplayPosts, posts, pagination } };
}

export default function Blog({ posts, initialDisplayPosts, pagination }) {
  console.log(posts, initialDisplayPosts, pagination);

  return (
    <>
      <PageInfo title="Blog" description={siteMetadata.description} />
      <Navbar />
      <Container>
        <ListLayout
          title="Our Blog"
          posts={posts}
          initialDisplayPosts={initialDisplayPosts}
          pagination={pagination}
        />
      </Container>
      <Footer />
    </>
  );
}
